<template>
  <div>
    <el-row
      :gutter="5"
      class="el-row"
    >
      <el-upload
        class="upload-demo"
        ref="add-upload"
        :action="UploadUrl()"
        capture="camera"
        el-upload
        :on-preview="handlePreview"
        :headers="headers"
        :on-remove="handleRemove"
        :file-list="fileList"
        :on-success="handlesuccess"
        multiple
        :auto-upload="false"
      >
        <el-button
          type="primary"
          slot="trigger"
          size="small"
        >选取文件</el-button>
        <el-button
          v-loading.fullscreen.lock="loading"
          type="success"
          size="small"
          style="margin-left: 10px;"
          @click="submitUpload('add')"
        >上传到服务器</el-button>
        <div
          slot="tip"
          class="el-upload__tip"
        >文件名中不可含有特殊符号且单个文件不能超过4M</div>
      </el-upload>

      <!-- <label> 筛选状态</label> -->
      <el-button-group>
        <el-button
          type="primary"
          icon="el-icon-arrow-left"
          @click="handleget(0)"
        >未报销</el-button>
        <el-button
          type="primary"
          @click="handleget()"
        >全部</el-button>
        <el-button
          type="primary"
          @click="handleget(1)"
        >已报销<i class="el-icon-arrow-right el-icon--right"></i></el-button>
      </el-button-group>
    </el-row>

    <template>
      <section>
        <!--工具条-->

        <!--列表-->
        <el-table
          border
          :data="listData"
          highlight-current-row
          @current-change="selectCurrentRow"
          v-loading="listLoading"
          @selection-change="selsChange"
          style="width: 100%;"
        >
          <el-table-column
            type="index"
            width="80"
          >
          </el-table-column>
          <el-table-column
            prop="InvoiceName"
            label="发票名称"
            width="180"
          >

          </el-table-column>
          <el-table-column
            prop="InvoiceNo"
            label="发票号码"
            width="180"
          >
          </el-table-column>
          <el-table-column
            prop="ItemName"
            label="项目名称"
          >
            <template slot-scope="scope">
              <el-input
                v-model="scope.row.ItemName"
                :disabled="scope.row.RBSNo!=0"
              ></el-input>
            </template>
          </el-table-column>
          </el-table-column>
          <el-table-column
            prop="RB"
            sortable
            label="已用单据"
          >
          </el-table-column>

          <el-table-column
            :formatter="formatData"
            prop="InvoiceDate"
            sortable
            label="开票日期"
          >
            <template slot-scope="scope">
              <el-date-picker
                v-model="scope.row.InvoiceDate"
                align="right"
                style="width:90%"
                type="date"
                :disabled="scope.row.RBSNo!=0"
                placeholder="选择日期"
                :picker-options="pickerOptions"
              >
              </el-date-picker>
            </template>
          </el-table-column>
          <el-table-column
            prop="Amount"
            sortable
            label="金额"
          >
          </el-table-column>
          <el-table-column
            prop="Count"
            label="张数"
          >
          </el-table-column>
          <el-table-column
            :formatter="formatData2"
            sortable
            prop="CreateTime"
            label="上传日期"
          >
          </el-table-column>
          <el-table-column
            label="发票状态"
            width="180"
          >
            <template slot-scope="scope">
              <div
                slot="reference"
                class="name-wrapper"
              >
                <el-tag
                  size="medium"
                  :type="scope.row.Status === '0' ? 'success'  :scope.row.Status === '1' ? 'warning'  :'danger'"
                >{{ scope.row.StatusInfo }}</el-tag>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            fixed="right"
            label="操作"
            width="100"
          >
            <template slot-scope="scope">
              <el-button
                @click="deleteInvoice(scope.row)"
                type="text"
                size="small"
              >删除</el-button>
              <el-button
                @click="updateInvoice(scope.row)"
                type="text"
                size="small"
              >保存</el-button>
            </template>
          </el-table-column>
        </el-table>

        <!--工具条-->
        <el-col
          :span="24"
          class="toolbar"
        >
          <el-pagination
            layout="prev, pager, next"
            @current-change="handleCurrentChange"
            :page-size="50"
            :total="total"
            style="float:right;"
          >
          </el-pagination>
        </el-col>
      </section>
    </template>
  </div>

</template>

<script >
import util from '../../../util/date'
import Toolbar from "../../components/Toolbar";
import { testapi, getListInvoicePage, removeListInvoice, editListInvoice } from '../../api/api';
import { getButtonList } from "../../promissionRouter";
export default {
  components: { Toolbar },
  data() {
    return {
      filters: {
        name: ''
      },
      headers: {
        Authorization: ''
      },
      pickerOptions: {
        disabledDate(v) {
          // return v.getTime() < new Date().getTime() - 86400000;
          // return v.getTime() < new Date().getTime() - 86400000;
        }
      },
      fileList: [],
      huanjing: '',
      loading: false,
      total: 0,
      buttonList: [],
      currentRow: null,
      page: 1,
      listLoading: false,
      sels: [],//列表选中列
      UploadPath: '',
      testUploadPath: '',
      DownPath: '',
      testDownPath: '',
      listData: [],
    }
  },
  methods: {
    UploadUrl: function() {
      var UploadPath = this.huanjing == 'production' ? global.UploadPath : global.testUploadPath;
      return UploadPath;
    },
    handlesuccess(response, file, fileList) {

      if (response.success == true) {

        for (let index = 0; index < response.response.length; index++) {
          var tmpresponse = response.response[index];
          //如果该发票不在明细内则加入
          if (this.listData.filter((item, i) => {
            return item.InvoiceNo == tmpresponse.InvoiceNo;
          }).length == 0) {
            this.listData.push(tmpresponse); //加到发票明细中
            fileList.find(a => a.name == file.name).name = tmpresponse.FileName;//文件改名

          }
          else { //如果发票重复上传，自动删除
            const index = fileList.findIndex(text => text.name === file.name);
            fileList.splice(index, 1);
          }
        }
      }
      else {
        this.$message({
          showClose: true,
          message: response.msg,
          type: 'error',
          duration: 0
        });
      }
      this.loading = false;
    },
    handleRemove(file, fileList) {
    },
    handlePreview(file) {

    },
    submitUpload(AddorEdit) {
      this.loading = true;
      if (AddorEdit == 'edit') {
        this.$refs['edit-upload'].submit();
      }
      else if (AddorEdit == 'deal') {
        this.$refs['deal-upload'].submit();
      }
      else {
        this.$refs['add-upload'].submit();
      }
    },
    formatData: function(row, column) {
      return (!row.InvoiceDate || row.InvoiceDate == '') ? '' : util.formatDate.format(new Date(row.InvoiceDate), 'yyyy-MM-dd');
    },
    formatData2: function(row, column) {
      return (!row.CreateTime || row.CreateTime == '') ? '' : util.formatDate.format(new Date(row.CreateTime), 'yyyy-MM-dd');
    },
    handleCurrentChange(val) {
      this.page = val;
      this.handleget();
    },
    //获取列表
    handleget(key) {
      let para = {
        page: this.page,
        key: key
      };
      this.listLoading = true;
      testapi();
      getListInvoicePage(para).then((res) => {
        this.total = res.data.response.dataCount;
        this.listData = res.data.response.data;
        this.listLoading = false;
        this.getfpsum();
      });

      console.log(this.listData);


    },
    getfpsum() {
      var that = this;
      if (that.listData.length > 0) {
        //求合计
        var s = 0;
        var s2 = 0;
        var z1 = '0';
        var z2 = '通过';
        that.listData.forEach(function(val, idx, arr) {
          s += parseFloat(val.Amount);
          s2 += parseFloat(val.Count);
          if (val.Status != '0' && val.Status != '1') {
            z1 = '2';
            z2 = '错误';
          }
        }, 0);
        s = Number(s.toFixed(2));
        // s2 = s2.toFixed(2);

        //判断整体状态
        var heji = {
          InvoiceName: '合计',
          Amount: s,
          ItemName: '',
          Count: s2,
          Status: z1,
          StatusInfo: z2,

          // Amount: 118,
          // BuyCode: null,
          // BuyName: null,
          // Count: 1,
          // CreateBy: "yechen",
          // CreateId: 42,
          // CreateTime: "2022-01-06T16:37:21+08:00",
          // Entry: null,
          // FileName: null,
          // Id: 486,
          // InvoiceCode: null,
          // InvoiceDate: "2022-02-02T00:00:00+08:00",
          // InvoiceName: "手工新增",
          // InvoiceNo: "1010",
          // IsDeleted: false,
          // IsUpByPeo: "1",
          // ItemName: "12333",
          // ModifyBy: "yechen",
          // ModifyId: 42,
          // ModifyTime: "2022-01-06T16:31:18+08:00",
          // RB: "GRBXSQ20220106002",
          // RBSNo: 119,
          // SaleCode: null,
          // SaleContact: null,
          // SaleName: null,
          // Status: "0",
          // StatusInfo: "正确",
          // Type: 99
        };
        that.listData.push(heji);

      }
    },
    callFunction(item) {
      this.filters = {
        name: item.search
      };
      this[item.Func].apply(this, item);
    },
    deleteInvoice(row) {
      // const index = this.listData.findIndex(a => a.InvoiceNo === row.InvoiceNo);
      // this.listData.splice(index, 1);
      // const index2 = this.fileList.findIndex(text => text.name === row.FileName);
      // this.fileList.splice(index2, 1);
      this.$confirm('确认删除该发票吗?', '提示', {
        type: 'warning'
      }).then(() => {
        this.listLoading = true;
        let para = { Id: row.Id };
        removeListInvoice(para).then((res) => {
          if (util.isEmt.format(res)) {
            this.listLoading = false;
            return;
          }
          this.listLoading = false;
          if (res.data.success) {
            this.$message({
              message: '删除成功',
              type: 'success'
            });
          } else {
            this.$message({
              message: res.data.msg,
              type: 'error'
            });
          }
          this.handleget();
        });
      }).catch(() => {
      });
    },
    updateInvoice(row) {
      this.$confirm('确认修改该发票吗?', '提示', {
        type: 'warning'
      }).then(() => {
        let para = Object.assign({}, row);
        editListInvoice(para).then((res) => {

          if (util.isEmt.format(res)) {
            this.editLoading = false;
            return;
          }
          if (res.data.success) {
            this.editLoading = false;
            this.$message({
              message: res.data.msg,
              type: 'success'
            });
            this.editFormVisible = false;
            this.handleget();
          } else {
            this.$message({
              message: res.data.msg,
              type: 'error'
            });
          }
        });
      }).catch(() => {
      });
    },
    selectCurrentRow(val) {
      this.currentRow = val;
    },
    selsChange: function(sels) {
      this.sels = sels;
    },
  },
  mounted() {
    this.handleget();
    let tokenStr = window.localStorage.Token;
    this.headers = {
      Authorization: "Bearer " + tokenStr
    };
    this.huanjing = process.env.NODE_ENV;
    UploadPath = this.huanjing == 'production' ? global.UploadPath : global.testUploadPath;
    // let routers = window.localStorage.router
    //   ? JSON.parse(window.localStorage.router)
    //   : [];
    //this.buttonList = getButtonList(this.$route.path, routers);
  }
}
</script>
<style>
.scan {
  height: 100%;
}
#bcid {
  width: 100%;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 3rem;
  text-align: center;
  color: #fff;
  background: #ccc;
}
footer {
  position: absolute;
  left: 0;
  bottom: 1rem;
  height: 2rem;
  line-height: 2rem;
  z-index: 2;
}
footer button {
  height: 0.88rem;
  line-height: 0.88rem;
  text-align: center;
  background-color: #f4f4f4;
  color: #fff;
}
.prev {
  position: absolute;
  display: inline-block;
  height: 0.36rem;
  width: 0.36rem;
  background-size: 0.36rem 0.36rem;
  vertical-align: middle;
  left: 0.18rem;
  top: 0.17rem;
  z-index: 100;
}
</style>